module.exports = __webpack_public_path__ + "static/media/faq.9b97ac4d.png";